import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "task-image-pagination"
};
import nodata from "@/assets/img/no-data.png";
import { ImageApi } from '@/api/ai/image';
import ImageDetail from './ImageDetail.vue';
import ImageCard from './ImageCard.vue';
import { ElLoading } from 'element-plus';
import { AiImageStatusEnum } from '@/views/aip/utils/constants';
import download from '@/utils/download';
import { onMounted, onUnmounted, reactive, ref } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
import { useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'ImageList',
  emits: ['onRegeneration'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const message = useMessage(); // 消息弹窗
    const router = useRouter(); // 路由
    // 图片分页相关的参数
    const queryParams = reactive({
      pageNo: 1,
      pageSize: 10,
      publicStatus: false
    });
    const pageTotal = ref(0); // page size
    const imageList = ref([]); // image 列表
    const imageListLoadingInstance = ref(); // image 列表是否正在加载中
    const imageListRef = ref(); // ref
    // 图片轮询相关的参数（正在生成中的）
    const inProgressImageMap = ref({}); // 监听的 image 映射，一般是生成中（需要轮询），key 为 image 编号，value 为 image
    const inProgressTimer = ref(); // 生成中的 image 定时器，轮询生成进展
    // 图片详情相关的参数
    const isShowImageDetail = ref(false); // 图片详情是否展示
    const showImageDetailId = ref(0); // 图片详情的图片编号
    /** 处理查看绘图作品 */
    const handleViewPublic = () => {
      router.push({
        name: 'AiImageSquare'
      });
    };
    /** 查看图片的详情  */
    const handleDetailOpen = async () => {
      isShowImageDetail.value = true;
    };
    /** 关闭图片的详情  */
    const handleDetailClose = async () => {
      isShowImageDetail.value = false;
    };
    /** 获得 image 图片列表 */
    const getImageList = async () => {
      try {
        // 1. 加载图片列表
        imageListLoadingInstance.value = ElLoading.service({
          target: imageListRef.value,
          text: '加载中...'
        });
        const {
          list,
          total
        } = await ImageApi.getImagePageMy(queryParams);
        imageList.value = list;
        pageTotal.value = total;
        // 2. 计算需要轮询的图片
        const newWatImages = {};
        imageList.value.forEach(item => {
          if (item.status === AiImageStatusEnum.IN_PROGRESS) {
            newWatImages[item.id] = item;
          }
        });
        inProgressImageMap.value = newWatImages;
      } finally {
        // 关闭正在“加载中”的 Loading
        if (imageListLoadingInstance.value) {
          imageListLoadingInstance.value.close();
          imageListLoadingInstance.value = null;
        }
      }
    };
    /** 轮询生成中的 image 列表 */
    const refreshWatchImages = async () => {
      const imageIds = Object.keys(inProgressImageMap.value).map(String);
      if (imageIds.length == 0) {
        return;
      }
      const list = await ImageApi.getImageListMyByIds(imageIds);
      if (list && list.length > 0) {
        const newWatchImages = {};
        list.forEach(image => {
          if (image.status === AiImageStatusEnum.IN_PROGRESS) {
            newWatchImages[image.id] = image;
          } else {
            const index = imageList.value.findIndex(oldImage => image.id === oldImage.id);
            if (index >= 0) {
              // 更新 imageList
              imageList.value[index] = image;
            }
          }
        });
        inProgressImageMap.value = newWatchImages;
      }
    };
    /** 图片的点击事件 */
    const handleImageButtonClick = async (type, imageDetail) => {
      // 详情
      if (type === 'more') {
        showImageDetailId.value = imageDetail.id;
        await handleDetailOpen();
        return;
      }
      // 删除
      if (type === 'delete') {
        await message.confirm(`是否删除照片?`);
        await ImageApi.deleteImageMy(imageDetail.id);
        await getImageList();
        message.success('删除成功!');
        return;
      }
      // 下载
      if (type === 'download') {
        await download.image({
          url: imageDetail.picUrl
        });
        return;
      }
      // 重新生成
      if (type === 'regeneration') {
        await emits('onRegeneration', imageDetail);
        return;
      }
    };
    /** 处理 Midjourney 按钮点击事件  */
    const handleImageMidjourneyButtonClick = async (button, imageDetail) => {
      // 1. 构建 params 参数
      const data = {
        id: imageDetail.id,
        customId: button.customId
      };
      // 2. 发送 action
      await ImageApi.midjourneyAction(data);
      // 3. 刷新列表
      await getImageList();
    };
    __expose({
      getImageList
    }); // 暴露组件方法
    const emits = __emit;
    /** 组件挂在的时候 */
    onMounted(async () => {
      // 获取 image 列表
      await getImageList();
      // 自动刷新 image 列表
      inProgressTimer.value = setInterval(async () => {
        await refreshWatchImages();
      }, 1000 * 3);
    });
    /** 组件取消挂在的时候 */
    onUnmounted(async () => {
      if (inProgressTimer.value) {
        clearInterval(inProgressTimer.value);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_Pagination = _resolveComponent("Pagination");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_card, {
        class: "dr-task",
        "body-class": "task-card",
        shadow: "never"
      }, {
        header: _withCtx(() => [_cache[3] || (_cache[3] = _createTextVNode(" 绘画任务 ")), _createVNode(_component_el_button, {
          type: "primary",
          class: "ml-[5px]",
          size: "small",
          onClick: handleViewPublic
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("绘画作品")])),
          _: 1
        })]),
        default: _withCtx(() => [!imageList.value.length ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 0,
          description: "暂无数据",
          image: _unref(nodata)
        }, null, 8, ["image"])) : _createCommentVNode("", true), _createElementVNode("div", {
          class: "task-image-list",
          ref_key: "imageListRef",
          ref: imageListRef
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageList.value, image => {
          return _openBlock(), _createBlock(ImageCard, {
            key: image.id,
            detail: image,
            onOnBtnClick: handleImageButtonClick,
            onOnMjBtnClick: handleImageMidjourneyButtonClick
          }, null, 8, ["detail"]);
        }), 128))], 512), _createElementVNode("div", _hoisted_1, [_createVNode(_component_Pagination, {
          total: pageTotal.value,
          page: queryParams.pageNo,
          "onUpdate:page": _cache[0] || (_cache[0] = $event => queryParams.pageNo = $event),
          limit: queryParams.pageSize,
          "onUpdate:limit": _cache[1] || (_cache[1] = $event => queryParams.pageSize = $event),
          onPagination: getImageList
        }, null, 8, ["total", "page", "limit"])])]),
        _: 1
      }), _createVNode(ImageDetail, {
        show: isShowImageDetail.value,
        id: showImageDetailId.value,
        onHandleDrawerClose: handleDetailClose
      }, null, 8, ["show", "id"])], 64);
    };
  }
});